import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ClassroomFilterDto } from 'src/app/data/models/dto/classroom-filter.dto';
import { ClassRoomsService } from 'src/app/data/services/classroom.service';
import { UserUtil } from 'src/app/data/utils/user.utils';
import { FlatNode } from '../select-hierarquical-list/model/flat.node.interface';
import { SimpleNode } from '../select-hierarquical-list/model/simple.node.interface';

@Component({
  selector: 'app-classroom-select',
  templateUrl: './classroom-select.component.html',
  styleUrls: ['./classroom-select.component.scss'],
})
export class ClassroomSelectComponent implements OnChanges {
  @Output() selectEvent = new EventEmitter<string[]>();
  @Output() loaded = new EventEmitter<boolean>();
  @Input() year?: string = ''; // new Date().getFullYear().toString();
  @Input() initialIds: string[] = [];
  idsSchool: string[] = this.userUtil.getSchools().map((school) => school.id);
  @Input() placeholder = 'Selecione a Turma';
  @Input() disabled: boolean = false;
  filterText = this.placeholder;
  segmentTreeData: SimpleNode[] = [];
  selectedIdsClassrooms = this.initialIds;
  isOpen = false;

  loading: boolean = false;

  constructor(
    private classroomsService: ClassRoomsService,
    private userUtil: UserUtil
  ) {}

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (
      changes.year &&
      changes.year.currentValue &&
      changes.year.currentValue != changes.year.previousValue
    ) {
      this.selectedIdsClassrooms = [];
      await this.loadSegmentTree();

      this.updateFilterText();
    }

    if (changes.initialIds) {
      if (changes.initialIds.currentValue.length == 0) {
        this.selectedIdsClassrooms = [];

        this.updateFilterText();
        return;
      }
      if (changes.initialIds.currentValue.length > 0) {
        this.selectedIdsClassrooms = changes.initialIds.currentValue;

        if (this.segmentTreeData.length === 0) {
          await this.loadSegmentTree();
          this.updateFilterText();
        }
        const selectedNames = this.getClassroomNamesByIds(changes.initialIds.currentValue);
      }
    }
  }

  handleSelectClassroom(classrooms: FlatNode[]) {
    this.isOpen = false;
    const ids = classrooms.map((classroom) => classroom.id);
    this.selectedIdsClassrooms = ids;

    this.updateFilterText();
    this.selectEvent.emit(ids);
  }

  get hasClassrooms(): boolean {
    return this.segmentTreeData && this.segmentTreeData.length > 0;
  }


  private formatSelectedClassroomsText(classrooms: string[]): string {
    let classroomsText = '';
    if (classrooms.length >= 1) {
      classroomsText = classrooms[0];
      if (classrooms.length > 1) {
        classroomsText = classroomsText
          .concat(' +')
          .concat((classrooms.length - 1).toString());
      }
    }
    return classroomsText;
  }

  private async loadSegmentTree(): Promise<void> {
    try {
      const filter: ClassroomFilterDto = {
        year: this.year,
        idSchool: this.idsSchool[0],
      };
      const tree = await this.classroomsService.getTree(filter).toPromise();
      this.segmentTreeData = tree.map((seg) => ({
        id: seg.id,
        name: seg.name,
        children: seg.series.map((ser) => ({
          name: ser.name,
          children: ser.classRooms.map((cls) => ({
            id: cls.id,
            name: cls.name,
          })),
        })),
      }));
      this.loaded.emit(true);
    } catch (error: any) {
      if (error.status === 404) {
        this.segmentTreeData = [];
      } else {
        console.error(error);
        this.loaded.emit(false);
      }
    } finally {
      this.loading = false;
    }
  }

  private getClassroomNamesByIds(ids: string[]): string[] {
    const selectedNames: string[] = [];
    this.segmentTreeData.forEach(segment => {
      segment.children?.forEach(series => {
        series.children?.forEach(classroom => {
          if (ids.includes(classroom.id!)) {
            selectedNames.push(classroom.name);
          }
        });
      });
    });
    return selectedNames;
  }

  private updateFilterText(): void {
    if (this.loading) {
      this.filterText = 'Carregando...';
      return;
    }

    if (!this.segmentTreeData || this.segmentTreeData.length === 0) {
      this.filterText = 'Nenhuma turma';
      return;
    }

    if (!this.selectedIdsClassrooms || this.selectedIdsClassrooms.length === 0) {
      this.filterText = this.placeholder;
      return;
    }

    const selectedNames = this.getClassroomNamesByIds(this.selectedIdsClassrooms);
    this.filterText = this.formatSelectedClassroomsText(selectedNames);
  }

}
